import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "input",
    "latInput",
    "lonInput",
    "withRadius",
    "withRadiusSelect",
    "stateSelect",
  ];
  declare autocomplete: google.maps.places.Autocomplete;

  declare inputTarget: HTMLInputElement;
  declare latInputTarget: HTMLInputElement;
  declare lonInputTarget: HTMLInputElement;
  declare withRadiusTarget: HTMLDivElement;
  declare withRadiusSelectTarget: HTMLSelectElement;
  declare stateSelectTarget: HTMLSelectElement;
  declare hasStateSelectTarget: boolean;

  connect(): void {
    if (typeof google != "undefined") {
      this.initAutocomplete();
    }

    this.toggle();
  }

  initAutocomplete(): void {
    this.autocomplete = new google.maps.places.Autocomplete(this.inputTarget);
    this.autocomplete.setFields(
      this.hasStateSelectTarget
        ? ["geometry", "address_components"]
        : ["geometry"]
    );
    this.autocomplete.setOptions({
      componentRestrictions: { country: ["au"] },
    });

    this.autocomplete.addListener(
      "place_changed",
      this.handlePlaceChanged.bind(this)
    );
    this.inputTarget.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    });
  }

  handlePlaceChanged(): void {
    const place = this.autocomplete?.getPlace();
    if (place?.geometry) {
      this.latInputTarget.value = place.geometry.location.lat().toString();
      this.lonInputTarget.value = place.geometry.location.lng().toString();
      this.syncState(place);
    } else {
      this.latInputTarget.value = "";
      this.lonInputTarget.value = "";
    }
    this.toggle();
  }

  // Keep the State filter in line with the picked suburb, so the two never
  // contradict (e.g. a Brisbane suburb while State is still the job's VIC).
  syncState(place: google.maps.places.PlaceResult): void {
    if (!this.hasStateSelectTarget) return;

    const state = place.address_components?.find((component) =>
      component.types.includes("administrative_area_level_1")
    )?.short_name;
    const hasOption = Array.from(this.stateSelectTarget.options).some(
      (option) => option.value === state
    );
    if (!state || !hasOption) return;

    this.stateSelectTarget.value = state;
    this.stateSelectTarget.dispatchEvent(new Event("change"));
  }

  toggle(): void {
    if (!this.inputTarget.value.trim()) {
      this.withRadiusTarget.classList.add("hidden");
      this.withRadiusSelectTarget.disabled = true;
    } else {
      this.withRadiusTarget.classList.remove("hidden");
      this.withRadiusSelectTarget.disabled = false;
    }
  }
}
